<template>
    <div style="display: flex;">
        <div class="tim_userlist">
            <div class="itmes" v-for="(item, index) in nowFriendList" :key="index" @click="getUserInfo(item)">
                <div class="items_img">
                    <img :src="item.user_info
                        .avatar" alt="" srcset="">
                </div>
                <div class="items_cont">
                    <div class="items_top">
                        <div class="items_name">{{ item.user_info.nickname }}</div>
                    </div>
                </div>
            </div>
            <div class="kongts" v-if="nowFriendList.length == ''">
                <div>
                    <img src="../../assets/tim/leftkong.png" alt="" srcset="">
                    <div class="texts">
                        暂无联系人
                    </div>
                </div>
            </div>
        </div>


        <div class="boy" v-if="wordList.length != 0">
            <div class="boy_top">
                <div class="text">{{ nowUserInfo.user_info.nickname }}</div>
                <div class="z_btn" @click="gohuihuaNow"> 发消息</div>
            </div>
            <div class="tim_cont_c " @scroll="scrollEventSay">
                <div v-for="(item, index) in wordList" :key="item.id">
                    <div class="tim_time" v-show="index == 0">
                        {{ item.createtime | dateFormat }}
                    </div>
                    <div v-if="index != 0" class="tim_time">
                        <span v-if="item.createtime - wordList[index - 1].createtime > 5 * 60">
                            {{ item.createtime | dateFormat }}
                        </span>
                    </div>

                    <div v-if="item.type == 'system'" class="tim_system">
                        <i class="el-icon-warning"></i>
                        <span>
                            {{ item.message }}
                        </span>
                    </div>
                    <div v-if="item.type != 'system'">
                        <div class="left_cont_i" v-if="item.sender_id != userinfo.id">
                            <img class="avatar" :src="item.user_info.avatar" alt="" srcset="">
                            <div v-if="item.type == 'default'" class="xx" style="margin-left: 10px;">
                                {{ item.message }}
                            </div>
                            <div v-if="item.type == 'file'" class="file xx" style="margin-left: 10px;">
                                <div class="file_flex">
                                    <div class="imgs">
                                        <img :src="FileIcon(item)" alt="">
                                    </div>
                                    <div>
                                        <div class="filename">{{ item.filename }}</div>
                                        <div class="filesize"> {{ item.c }} </div>
                                    </div>
                                    <button class="preview-file-btn" :disabled="isPreviewFile(item)" @click="hanldePreViewFile(item)">
                                        预览文件
                                    </button>
                                    <div class="imgsd" @click="download(item)">
                                        <img src="../../assets/tim/down.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.type == 'image'" style="margin-left: 10px;">
                                <el-image :preview-src-list="[item.message]"
                                    style="max-width: 160px;height: 100px;border-radius: 6px;"
                                    :src="item.message"></el-image>
                            </div>
                            <div v-if="item.type == 'link_text'"  v-html="item.message" class="xx" style="margin-left: 10px;">

                            </div>
                        </div>

                        <div class="right_cont_i" v-if="item.sender_id == userinfo.id ">
                            <div class="rig">
                                <img class="avatar" :src="item.user_info.avatar" alt="" srcset="">
                                <div v-if="item.type == 'default'" class="xx" style="margin-right: 10px;">
                                    {{ item.message }}
                                </div>
                                <div v-if="item.type == 'file'" class="file xx" style="margin-right: 10px;">
                                    <div class="file_flex">
                                        <div class="imgs">
                                            <img :src="FileIcon(item)" alt="">
                                        </div>
                                        <div>
                                            <div class="filename">{{ item.filename | urlCode }}</div>
                                            <div class="filesize"> {{ item.filesize }} </div>
                                        </div>
                                        <button class="preview-file-btn" :disabled="isPreviewFile(item)" @click="hanldePreViewFile(item)">
                                            预览文件
                                        </button>
                                        <div class="imgsd" @click="download(item)">
                                            <img src="../../assets/tim/down.png" alt="">
                                        </div>
                                    </div>
                                </div>

                                <div v-if="item.type == 'image'" class="img" style="margin-right: 10px;">
                                    <el-image :preview-src-list="[item.message]"
                                        style="max-width: 160px;height: 100px;border-radius: 6px;"
                                        :src="item.message"></el-image>
                                </div>
                                <div v-if="item.type == 'link_text'"  v-html="item.message" class="xx" style="margin-right: 10px;">

                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

            </div>
        </div>
        <div class="kongts1" v-else>
            <div>
                <img src="../../assets/tim/rightkong.png" alt="" srcset="">
                <div class="texts">
                    暂无信息
                </div>
            </div>
        </div>
        <FilePreviewDialog 
        :visible.sync="previewVisible"
        :url="previewUrl" 
        :fileName="previewFileName"
        />
    </div>
</template>

<script>
import { sessionList, messageList } from '@/api/txim'
import { mapState } from 'vuex'
import FilePreviewDialog from '../MultiFilePreView/MultiFilePreView.vue';
import { saveAs } from 'file-saver';

export default {
    components: { FilePreviewDialog },
    name: '',
    data() {
        return {
            nowFriendList: [],
            nowUserInfo: {},
            wordList: [],
            scrollHeight: 0,
            concatShow: true,
            params: {
                page: 1,
                limit: 15,
                ztim_session_id: ''
            },
            previewUrl: '',
            previewFileName: '',
            previewVisible:false


        }
    },
    computed: {
        ...mapState(['userinfo'])
    },
    mounted() {
        sessionList().then(res => {
            if (res.code == 1) {
                this.nowFriendList = res.data.list
            }
        })
    },
    methods: {
        //查看详情
        goDetail() {
            //如果当前就在详情页 并且与要跳转的id一直就直接关闭弹窗
            let routerid = this.$route.query.id
            if (this.zhanshiinfo.id == routerid) {
                this.$emit('close')
            } else {
                this.$router.push({ path: "/gydetail", query: { id: this.zhanshiinfo.id } })
                this.$emit('close')
            }
        },
        getUserInfo(item) {
            this.nowid = item.user_two
            this.nowUserInfo = item
            this.params.ztim_session_id = item.id
            this.params.page = 1
            this.wordList = []
            messageList(this.params).then(res => {
                if (res.code == 1) {
                    this.wordList = res.data.list
                    if (this.wordList.length != 0) {
                        this.scrollEvent()
                    }
                }
            })
        },
        //去聊天
        gohuihuaNow() {
            let that = this
            let promise = this.tim.getUserProfile({
                userIDList: ['xj' + that.nowid] // 请注意：即使只拉取一个用户的资料，也需要用数组类型，例如：userIDList: ['user1']
            })
            promise.then(function (imResponse) {
                that.$emit('gohuihuaNow', imResponse.data[0])
            }).catch(function (imError) {
                console.warn('getUserProfile error:', imError);
            });
        },
        // 控制滚动条滚动到底部
        scrollEvent() {
            // 自动滚动到底部
            this.$nextTick(() => {
                let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                msg.scrollTop = msg.scrollHeight + 10
            });
        },
        // 监听滚动条的高度，滚动到顶部后拉取聊天数据
        scrollEventSay(e) {
            this.scrollHeight = e.srcElement.scrollHeight;
            if (e.srcElement.scrollTop == 0) {
                this.params.page++
                messageList(this.params).then(res => {
                    this.wordList.unshift(...res.data.list)
                    this.$nextTick(() => {
                        let msg = document.getElementsByClassName("tim_cont_c")[0]; // 获取对象
                        msg.scrollTop = msg.scrollHeight - this.scrollHeight; // 滚动高度
                    });
                })
            }
        },
        hanldePreViewFile(item){
            this.previewUrl = item.message
            this.previewFileName = item.filename
            this.previewVisible = true
        },
        isPreviewFile(item){
            const parts = item.filename.split('.')
            if (parts.length === 1) return true 
            const ext = parts.pop().toLowerCase()
            const previewTypes = [
                'txt', 'pdf', 'doc', 'docx', 'xls', 'xlsx',
                'ppt', 'pptx', 'zip'
            ]
            return !previewTypes.includes(ext)
        },
        FileIcon(item){
            const parts = item.filename.split('.')
            if (parts.length === 1) return require('../../assets/extlink.png')
            const ext = parts.pop().toLowerCase()
            const text = ['docx','doc','txt']
            if (text.includes(ext)){
                return require('../../assets/exttxt.png')
            }
            const audio = ['mp3', 'mp4']
            if (audio.includes(ext)){
                return require('../../assets/extadu.png')
            }
            const pdf = ['pdf']
            if (pdf.includes(ext)){
                return  require('../../assets/extpdf.png')
            }
            const excel = ['xls','xlsx','csv']
            if (excel.includes(ext)){
                return require('../../assets/extxls.png')
            }
            const rarzip = ['zip','rar','7z']
            if (rarzip.includes(ext)){
                return require('../../assets/extzip.png')
            }
            const ppt = ['ppt','pptx','psd', 'dwg', 'ai', 'cdr', 'tiff', 'eps', 'tif']
            if (ppt.includes(ext)){
                return  require('../../assets/extppt.png')
            }
            return require('../../assets/extlink.png')
        },
        download(item) {
            fetch(item.message).then(response => response.blob()).then(blob => {
                saveAs(blob, item.filename); // 设置你想要的文件名
            }).catch(error => console.error('下载失败:', error));
        }
    },
}
</script>
<style lang='scss' scoped>
.kongts {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250px;
    height: 700px;
    text-align: center;

    img {
        width: 42px;
        height: 42px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }

}

.kongts1 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 700px;
    text-align: center;
    width: 790px;

    img {
        width: 224px;
        height: 224px;
    }

    .texts {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
        line-height: 46px;
    }
}

.tim_userlist {
    border-right: 1px solid #eee;
    width: 250px;
    height: 700px;
    overflow: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
    &::-webkit-scrollbar-thumb {
        background: rgba(144, 147, 153, 0.3);
        cursor: pointer;
        border-radius: 4px;
    }

    .active {
        background-color: #eee !important;
    }

    .itmes {
        width: 220px;
        display: flex;
        margin: 14px auto;
        box-sizing: border-box;
        padding: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        align-items: center;

        .items_img {
            width: 40px;
            height: 40px;
            border-radius: 10px;

            img {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
        }

        .items_cont {
            flex: 1;
            margin-left: 9.2px;
        }

        .items_top {
            display: flex;
            justify-content: space-between;
            align-content: center;

            .items_name {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 14px;
                color: #000000;
            }

            .items_time {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #ADAAAA;
            }


        }

        .items_text {
            width: 140px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #ADAAAA;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .itmes:hover {
        background: #f4f4f4;
    }
}

.boy {
    width: 780px;

    .boy_top {
        width: 780px;
        border-bottom: 1px solid #eee;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        box-sizing: border-box;

        .text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
        }

        .btn {
            width: 100px;
            height: 40px;
            border-radius: 5px 5px 5px 5px;
            text-align: center;
            line-height: 40px;
            color: #000000;
            font-size: 14px;
        }
    }

    .tim_cont_c {
        height: 650px;
        overflow-y: auto;
        background: #F7F8FA;
        box-sizing: border-box;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;

        &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(144, 147, 153, 0.3);
            cursor: pointer;
            border-radius: 4px;
        }

        .icons {
            border: 1px solid red;
            margin-top: 100px;
        }

        .tim_time {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #ADAAAA;
            text-align: center;
        }

        .tim_system {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 13px;
            color: #f05151;
            text-align: center;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        .left_cont_i {
            margin: 16px;
            display: flex;
        }

        .avatar {
            width: 40px;
            height: 40px;
            border-radius: 6px;
        }

        .right_cont_i {
            margin: 16px;
            text-align: right;
        }

        .isread {
            font-size: 12px;
            position: absolute;
            bottom: 0%;
            left: -30px;
            color: #ADAAAA !important;
        }

        .preview-file-btn {
            width: 60px;
            height: 28px;
            padding: 0;
            font-size: 10px;
            font-weight: 600;
            border: 1px solid #409EFF; /* 细边框 */
            border-radius: 3px;
            background: rgba(64, 158, 255, 0.12);
            color: #409EFF;
            cursor: pointer;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            box-sizing: border-box; /* 确保尺寸精确 */
            line-height: 18px; /* 垂直居中 */
            letter-spacing: 0.3px;
            margin-left: 10px;
            margin-bottom: 20px;
        }

        /* 悬停状态 */
        .preview-file-btn:hover {
            background: rgba(64, 158, 255, 0.2);
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
            transform: translateY(-1px);
        }

        /* 点击状态 */
        .preview-file-btn:active {
            transform: translateY(1px);
            background: rgba(64, 158, 255, 0.3);
        }

        /* 禁用状态 */
        .preview-file-btn:disabled {
            border-color: #C0C4CC;
            background: #F5F7FA;
            color: #C0C4CC;
            cursor: not-allowed;
            box-shadow: none;
            transform: none;
        }

        /* 禁用状态下的hover */
        .preview-file-btn:disabled:hover {
            background: #F5F7FA;
        }

        .cobule {
            color: rgb(78, 78, 255) !important;
        }

        .rig {
            display: flex;
            flex-direction: row-reverse;
            position: relative;
        }

        .xx {
            max-width: 60%;
            background-color: #fff;
            border-radius: 4px;
            align-items: center;
            text-align: left;
            padding: 10px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            position: relative;
            white-space: pre-wrap;
        }

        .img {
            max-width: 60%;
            border-radius: 4px;
            align-items: center;
            text-align: left;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            position: relative;
        }

        .file {
            max-width: 60%;
            padding: 10px;
            background-color: #fff;
            border-radius: 4px;
            align-items: center;
            text-align: left;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            position: relative;

            .file_flex {
                display: flex;
                align-items: center;
            }

            .imgs {
                width: 40px;
                height: 40px;
                background: #E5FCFF;
                border-radius: 5px 5px 5px 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 10px;

                img {
                    width: 30px;
                    height: 36px;
                }
            }

            .imgsd {
                width: 34px;
                height: 34px;
                margin-left: 20px;
                cursor: pointer;
            }

            .filename {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
            }

            .filesize {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 12px;
                color: #ADAAAA;
            }
        }

        .xx::before {
            content: '';
            position: absolute;
            left: -5px;
            width: 8px;
            height: 8px;
            transform: rotate(45deg);
            background-color: #fff;
        }

        .rig>.xx::before {
            left: unset;
            right: -5px;
        }
    }
}
</style>